module.exports = [
    {
        "country": "Australia",
        "conversations": 1100,
        "visitors": 80801
    },
    {
        "country": "Facebook-Messenger",
        "conversations": 281,
        "visitors": 317
    },
    {
        "country": "New Zealand",
        "conversations": 10,
        "visitors": 172
    },
    {
        "country": "United States",
        "conversations": 3,
        "visitors": 8975
    },
    {
        "country": "Switzerland",
        "conversations": 1,
        "visitors": 14
    },
    {
        "country": "South Africa",
        "conversations": 1,
        "visitors": 15
    }
]